// extracted by mini-css-extract-plugin
export default {"wrapperPage":"Settings_wrapperPage__C4GQM","wrapperHeader":"Settings_wrapperHeader__x9fTx","title":"Settings_title__FF1+J","wrapperContent":"Settings_wrapperContent__D0tRG"};